var ObjectTypes = new Enum({
  ServiceZone: 1,
  Road: 2,
  SSegment: 3,
  LongObject: 4,
  DotObject: 5,
  Locality: 6,
  Vehicle: 7,
  Emergency: 8,
  WStation: 9,
  Video: 10,
  Work: 11,
  VideoCamera: 12
});
